import {
  // getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  searchInfo: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  searchedForm: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH',
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  transList: [],
  transInfo: {
    transId: '',
    colType: '',
    compId: '',
    projId: '',
    entityId: '',
    // ctrAcctId: '',
    // tgtCtrAcctId: '',
    transDt: '',
    transSummary: '',
    investInAmt: 0,
    investOutAmt: 0,
    finInAmt: 0,
    finOutAmt: 0,
    docMth: '',
    docIndex: 0,
    allowDuplicate: false,
    transRemarks: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  justUpdatedIndex: -1,
  editAction: '',
  editDocMth: '',
  editDocIndex: 0,
  editAllowDuplicate: false,
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjAcctReceiveTrans({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_ACCT_RECEIVE_TRANS, {
      data: {
        // transId: state.transInfo.transId,
        // colType: state.transInfo.colType,
        // compId: state.transInfo.compId,
        // projId: state.transInfo.projId,
        // entityId: state.transInfo.entityId,
        // ctrAcctId: state.transInfo.ctrAcctId,
        // tgtCtrAcctId: state.transInfo.tgtCtrAcctId,
        transDt: new Date(state.transInfo.transDt).getTime(),
        transSummary: state.transInfo.transSummary,
        investInAmt: Utils.covertNullToZero(state.transInfo.investInAmt),
        investOutAmt: Utils.covertNullToZero(state.transInfo.investOutAmt),
        finInAmt: Utils.covertNullToZero(state.transInfo.finInAmt),
        finOutAmt: Utils.covertNullToZero(state.transInfo.finOutAmt),
        docMth: state.transInfo.docMth,
        docIndex: state.transInfo.docIndex,
        allowDuplicate: state.transInfo.allowDuplicate,
        transRemarks: state.transInfo.transRemarks,
        //
        entityId: entityId,
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjAcctReceiveTrans({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      // transId: state.transInfo.transId,
      // colType: state.transInfo.colType,
      // compId: state.transInfo.compId,
      // projId: state.transInfo.projId,
      // entityId: state.transInfo.entityId,
      // ctrAcctId: state.transInfo.ctrAcctId,
      // tgtCtrAcctId: state.transInfo.tgtCtrAcctId,
      transDt: state.transInfo.transDt,
      transSummary: state.transInfo.transSummary,
      investInAmt: Utils.covertNullToZero(state.transInfo.investInAmt),
      investOutAmt: Utils.covertNullToZero(state.transInfo.investOutAmt),
      finInAmt: Utils.covertNullToZero(state.transInfo.finInAmt),
      finOutAmt: Utils.covertNullToZero(state.transInfo.finOutAmt),
      transRemarks: state.transInfo.transRemarks,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_RECEIVE_TRANS, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjAcctReceiveTrans({
    commit,
    state
  }, {transId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_ACCT_RECEIVE_TRANS + `?transId=${transId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async updateProjAcctReceiveTransDocIndex({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, docMth, docIndex, allowDuplicate, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      docMth,
      docIndex,
      allowDuplicate,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_RECEIVE_TRANS_DOC_INDEX, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async checkProjAcctReceiveTrans({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, checkedStatus, checkedComment, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      checkedStatus,
      checkedComment,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.CHECK_RSP_PROJ_ACCT_RECEIVE_TRANS, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async findProjAcctReceiveTransList({
    commit,
    state,
    rootState
  }, { transId, entityId, projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      transId: transId,
      entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await postReq(END_POINTS.FIND_RSP_PROJ_ACCT_RECEIVE_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateProjAcctReceiveTransList', response)
  },
  async downloadProjAcctReceiveTransList({
    commit,
    state,
    rootState
  }, { entityId, projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_ACCT_RECEIVE_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // console.log('exportExcelReq.resp:', response)
    return response
  },
  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  async updateSearchInfo(state, searchInfo) {
    state.searchInfo = {...searchInfo}
  },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  updateSearchType(state, value) {
    state.searchInfo.searchType = value
  },
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  updateSearchMonthType(state, value) {
    state.searchInfo.searchMonthType = value
  },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  updateSearchStartDt(state, value) {
    state.searchInfo.searchStartDt = value
  },
  updateSearchEndDt(state, value) {
    state.searchInfo.searchEndDt = value
  },
  updateSearchDocMth(state, value) {
    state.searchInfo.searchDocMth = value
  },
  updateSearchDocIndex(state, value) {
    state.searchInfo.searchDocIndex = value
  },
  updateSearchDocMonthIndex(state, value) {
    state.searchInfo.searchDocMonthIndex = value
  },
  updateSearchDocType(state, value) {
    state.searchInfo.searchDocType = value
  },
  //
  updateTransId(state, value) {
    state.transInfo.transId = value
  },
  updateColType(state, value) {
    state.transInfo.colType = value
  },
  updateCompId(state, value) {
    state.transInfo.compId = value
  },
  updateProjId(state, value) {
    state.transInfo.projId = value
  },
  updateEntityId(state, value) {
    state.transInfo.entityId = value
  },
  // updateCtrAcctId(state, value) {
  //   state.transInfo.ctrAcctId = value
  // },
  // updateTgtCtrAcctId(state, value) {
  //   state.transInfo.tgtCtrAcctId = value
  // },
  updateTransDt(state, value) {
    state.transInfo.transDt = value
  },
  updateTransSummary(state, value) {
    state.transInfo.transSummary = value
  },
  updateInvestInAmt(state, value) {
    state.transInfo.investInAmt = value
  },
  updateInvestOutAmt(state, value) {
    state.transInfo.investOutAmt = value
  },
  updateFinInAmt(state, value) {
    state.transInfo.finInAmt = value
  },
  updateFinOutAmt(state, value) {
    state.transInfo.finOutAmt = value
  },
  updateDocMth(state, value) {
    state.transInfo.docMth = value
  },
  updateDocIndex(state, value) {
    state.transInfo.docIndex = value
  },
  updateAllowDuplicate(state, value) {
    state.transInfo.allowDuplicate = value
  },
  updateTransRemarks(state, value) {
    state.transInfo.transRemarks = value
  },
  updateLockBy(state, value) {
    state.transInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.transInfo.lockOn = value
  },
  updateIndDel(state, value) {
    state.transInfo.indDel = value
  },
  updateCrtBy(state, value) {
    state.transInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.transInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.transInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.transInfo.updOn = value
  },
  //
  updateProjAcctReceiveTransList(state, list) {
    if (list.length) {
      state.transList = list
      // state.transList = []
    } else {
      state.transList = []
    }
  },
  updateProjAcctReceiveTransListItem(state, {row, index}) {
    if (state.transList && state.transList.length && index >= 0 && index < state.transList.length) {
      if (row) {
        Object.keys(row).forEach(key => {
          state.transList[index][key] = row[key]
        })
      } else {
        state.transList.splice(index, 1)
      }
    }
  },
  updateProjAcctReceiveTransListEmpty(state) {
    state.editIndex = -1
    state.justUpdatedIndex = -1
    state.transList = []
  },
  updateProjAcctReceiveTransEmpty(state) {
    state.transInfo.transId = ''
    state.transInfo.colType = ''
    state.transInfo.compId = ''
    state.transInfo.projId = ''
    state.transInfo.entityId = ''
    // state.transInfo.ctrAcctId = ''
    // state.transInfo.tgtCtrAcctId = ''
    state.transInfo.transDt = ''
    state.transInfo.transSummary = ''
    state.transInfo.investInAmt = Utils.covertZeroToNull(0)
    state.transInfo.investOutAmt = Utils.covertZeroToNull(0)
    state.transInfo.finInAmt = Utils.covertZeroToNull(0)
    state.transInfo.finOutAmt = Utils.covertZeroToNull(0)
    state.transInfo.docMth = ''
    state.transInfo.docIndex = 0
    state.transInfo.allowDuplicate = false
    state.transInfo.transRemarks = ''
    state.transInfo.lockBy = ''
    state.transInfo.lockOn = new Date(0)
    state.transInfo.crtBy = ''
    state.transInfo.crtOn = new Date(0)
    state.transInfo.updBy = ''
    state.transInfo.updOn = new Date(0)

    state.transInfo.indUsed = ''
  },
  updateProjAcctReceiveTransInfo(state, transInfo) {
    // debugger
    state.transInfo.transId = transInfo.transId
    state.transInfo.colType = transInfo.colType
    state.transInfo.compId = transInfo.compId
    state.transInfo.projId = transInfo.projId
    state.transInfo.entityId = transInfo.entityId
    // state.transInfo.ctrAcctId = transInfo.ctrAcctId
    // state.transInfo.tgtCtrAcctId = transInfo.tgtCtrAcctId
    state.transInfo.transDt = Utils.parseDate(transInfo.transDt)
    state.transInfo.transSummary = transInfo.transSummary
    state.transInfo.investInAmt = Utils.covertZeroToNull(transInfo.investInAmt)
    state.transInfo.investOutAmt = Utils.covertZeroToNull(transInfo.investOutAmt)
    state.transInfo.finInAmt = Utils.covertZeroToNull(transInfo.finInAmt)
    state.transInfo.finOutAmt = Utils.covertZeroToNull(transInfo.finOutAmt)
    state.transInfo.docMth = transInfo.docMth
    state.transInfo.docIndex = transInfo.docIndex
    state.transInfo.allowDuplicate = false
    state.transInfo.transRemarks = transInfo.transRemarks
    //
    state.transInfo.indUsed = transInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateJustUpdatedIndex(state, value) {
    state.justUpdatedIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  updateEditDocMth(state, value) {
    state.editDocMth = value
  },
  updateEditDocIndex(state, value) {
    state.editDocIndex = value
  },
  updateEditAllowDuplicate(state, value) {
    state.editAllowDuplicate = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('projAcctReceiveTransManage/updateProjAcctReceiveTransEmpty')
    let obj = {...state.transInfo}
    // debugger
    obj.isBottomRow = true
    state.transList.push(obj)
  },
  handleAdd(state, {row, index}) {
    // debugger
    this.commit('projAcctReceiveTransManage/updateProjAcctReceiveTransEmpty')
    this.commit('projAcctReceiveTransManage/updateEditIndex', index)
    this.commit('projAcctReceiveTransManage/updateJustUpdatedIndex', -1)
    this.commit('projAcctReceiveTransManage/updateEditAction', 'insert')
    //
    // this.commit('projAcctReceiveTransManage/updateCtrAcctId', ctrAcctId)
    // this.commit('projAcctReceiveTransManage/updateCostColId', costColId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('projAcctReceiveTransManage/updateProjAcctReceiveTransInfo', row)
    this.commit('projAcctReceiveTransManage/updateEditIndex', index)
    this.commit('projAcctReceiveTransManage/updateJustUpdatedIndex', -1)
    this.commit('projAcctReceiveTransManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/projAcctReceiveTransManage.js